<template>
  <div class="topbanner q-mt-sm">
    <div class="banner row full-width justify-between items-center content-center">
      <div class="col" style="max-width: 180px;">
        <q-img src="@/assets/img/website_logo.png" style="max-width: 180px; height: 100%;">
        </q-img>
      </div>
      <div class="col text-center gt-sm">
        <div class="text-h5 text-weight-bolder">自助报价系统</div>
      </div>
      <div class="col-auto">
        <q-icon name="fas fa-phone-alt" />
        13169651313（<q-icon name="fab fa-weixin" />）
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
}
</script>

<style scoped>
.topbanner {
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  /* z-index: 99999; */
}

.banner {
  background-image: linear-gradient(rgb(255, 255, 255, 0.5), rgba(255, 255, 255, 1)), url(img/title_bar.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% auto;
  /* 将背景图像的宽度拉伸至100% */
}
</style>